// Global slider variables
var productSlider;
var productThumbSlider;

function scrollThumbnailToView(selectedThumb) {
  if (!selectedThumb) return;

  const thumbnailContainer = document.querySelector('.yv-product-gallery-thumbs-container');
  if (!thumbnailContainer) return;

  const containerRect = thumbnailContainer.getBoundingClientRect();
  const thumbRect = selectedThumb.getBoundingClientRect();
  const currentTop = parseInt(thumbnailContainer.style.top) || 0;

  // Check if thumbnail is above the visible area
  if (thumbRect.top < containerRect.top) {
    const scrollAmount = containerRect.top - thumbRect.top + 20; // 20px padding
    const newTop = currentTop + scrollAmount;
    thumbnailContainer.style.top = newTop + 'px';
  }
  // Check if thumbnail is below the visible area
  else if (thumbRect.bottom > containerRect.bottom) {
    const scrollAmount = thumbRect.bottom - containerRect.bottom + 20; // 20px padding
    const newTop = currentTop - scrollAmount;
    thumbnailContainer.style.top = newTop + 'px';
  }
}

window.addEventListener('resize', function(event){
  findVisibleItems();
  initProductSlider();
  initProductThumbSlider();
});

function initProductSlider(section = document){
  let sliderMain = section.querySelector('[data-flickity-product-slider]');

  if(sliderMain && sliderMain.children.length > 0){
    let optionContainer = sliderMain.getAttribute('data-flickity-product-slider');

    if(optionContainer){
      var options = JSON.parse(optionContainer);
      if(sliderMain.hasAttribute("data-mobile-only")){
        if(window.innerWidth < 768 ){
          if (!sliderMain.classList.contains('flickity-enabled')) {
             window.productSlider = new Flickity(sliderMain,options);
            setTimeout(function(){
              window.productSlider.resize();
            },300)
          }
        }
        else{
          if (sliderMain.classList.contains('flickity-enabled')) {
            productSlider.destroy();
          }
        }
      }
      else if(sliderMain.hasAttribute("data-desktop-only")){
        if(window.innerWidth >= 768 ){
          if (!sliderMain.classList.contains('flickity-enabled')) {
              window.productSlider = new Flickity(sliderMain,options);
              setTimeout(function(){
                window.productSlider.resize();
              },300)
          }
        }
        else{
          if (sliderMain.classList.contains('flickity-enabled')) {
            window.productSlider.destroy();
            window.productSlider = null;
          }
        }
      }
      else{
        if (!sliderMain.classList.contains('flickity-enabled')) {
            window.productSlider = new Flickity(sliderMain,options);
            setTimeout(function(){
              window.productSlider.resize();
            },300)
        }
      }
      if(window.productSlider){
        window.productSlider.on( 'change', function( index ) {
          let sliderMain= window.productSlider.$element[0];
          sliderMain.querySelectorAll('.yv-youtube-video').forEach((video) => {
            video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
          });
          sliderMain.querySelectorAll('.yv-vimeo-video').forEach((video) => {
            video.contentWindow.postMessage('{"method":"pause"}', '*');
          });
          sliderMain.querySelectorAll('video').forEach((video) => video.pause() );

          // Auto-scroll thumbnail container to show active thumbnail
          setTimeout(() => {
            if (window.productThumbSlider) {
              const selectedThumb = window.productThumbSlider.element.querySelector('.is-selected');
              if (selectedThumb) {
                scrollThumbnailToView(selectedThumb);
              }
            }
          }, 100);
        });
      }
    }
  }
}

function initProductThumbSlider(section = document){
  let sliderMain = section.querySelector('[data-flickity-product-thumb-slider]');

  if(sliderMain && sliderMain.children.length > 0){
    let optionContainer = sliderMain.getAttribute('data-flickity-product-thumb-slider');
    if(optionContainer){
      var options = JSON.parse(optionContainer);
      if(sliderMain.hasAttribute("data-mobile-only")){
        if(window.innerWidth < 768 ){
          if (!sliderMain.classList.contains('flickity-enabled')) {
           window.productThumbSlider = new Flickity(sliderMain,options);
          window.productThumbSlider.resize();
          }
        }
        else{
          if (sliderMain.classList.contains('flickity-enabled')) {
            window.productThumbSlider.destroy();
          }
        }
      }
      else if(sliderMain.hasAttribute("data-desktop-only")){
        if(window.innerWidth >= 768 ){
          if (!sliderMain.classList.contains('flickity-enabled')) {
              window.productThumbSlider = new Flickity(sliderMain,options);
          window.productThumbSlider.resize();
          }
        }
        else{
          if (sliderMain.classList.contains('flickity-enabled')) {
            window.productThumbSlider.destroy();
          }
        }
      }
      else{
        if (!sliderMain.classList.contains('flickity-enabled')) {
            window.productThumbSlider = new Flickity(sliderMain,options);
          window.productThumbSlider.resize();
        }
      }
      if(window.productThumbSlider){
        window.productThumbSlider.on( 'change', function( index ) {
          let sliderMain= window.productThumbSlider.$element[0];
          sliderMain.querySelectorAll('.yv-youtube-video').forEach((video) => {
            video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
          });
          sliderMain.querySelectorAll('.yv-vimeo-video').forEach((video) => {
            video.contentWindow.postMessage('{"method":"pause"}', '*');
          });
          sliderMain.querySelectorAll('video').forEach((video) => video.pause() );
        });
      }
    }
  }
}

var productMediaModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: (function(){
          
          document.querySelectorAll('.yv-product-model-item').forEach((model) => {   
            let model3D = model.querySelector('model-viewer')
            model.modelViewerUI = new Shopify.ModelViewerUI(model3D);
            model3D.addEventListener('shopify_model_viewer_ui_toggle_play', function(evt) {
              model.querySelectorAll('.close-product-model').forEach(el => {
                el.classList.remove('hidden');
              });
              if(productSlider){
                productSlider.options.draggable = false;
                productSlider.updateDraggable();
              }
            }.bind(this));

            model3D.addEventListener('shopify_model_viewer_ui_toggle_pause', function(evt) {
              model.querySelectorAll('.close-product-model').forEach(el => {
                el.classList.add('hidden');
              });
              if(productSlider){
                productSlider.options.draggable = true;
                productSlider.updateDraggable();
              }
            }.bind(this));
			
            model.querySelectorAll('.close-product-model').forEach(el => {
              el.addEventListener('click', function() {
                if (model3D) {
                  model.modelViewerUI.pause();
                }
              }.bind(this))
            });
            
          });

        })
      }
    ]);
  },

  setupShopifyXR(errors) {
    if (!errors) {
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', () =>
                                  this.setupShopifyXR()
        );
        return;
      }
      document.querySelectorAll('[id^="product3DModel-"]').forEach((model) => {
        window.ShopifyXR.addModels(JSON.parse(model.textContent));
      });
      window.ShopifyXR.setupXRElements();
    }
  },
};

window.addEventListener('DOMContentLoaded', () => {
  let productModel = document.querySelectorAll('[id^="product3DModel-"]');
  if (productMediaModel && productModel.length > 0 ){
    productMediaModel .loadShopifyXR();
  }
});

function findVisibleItems(){
  let mainSliderParent =  document.getElementById('yv-product-gallery-slider');
  if(mainSliderParent){
    var elements = mainSliderParent.getElementsByClassName('gallery-main-item');

    var thumbs = mainSliderParent.getElementsByClassName('gallery-thumbs-item');
    
    window.addEventListener('scroll', function(event){
      Array.from(elements).forEach(function(item) {
        if (isOnScreen(item)) {
          thumbs = mainSliderParent.getElementsByClassName('gallery-thumbs-item');
          
          var relatedThumb = mainSliderParent.querySelector('.gallery-thumbs-item[data-image="'+item.id+'"]');
          if(relatedThumb){
            Array.from(thumbs).forEach(function(thumb) {
              if(thumb != relatedThumb){
              thumb.classList.remove('active');
              }
            });
            if(!relatedThumb.classList.contains('active')){
              relatedThumb.classList.add('active');

              // Auto-scroll thumbnail container to show the active thumbnail
              var thumbnailContainer = document.querySelector('.yv-product-gallery-thumbs-container');
              if(thumbnailContainer) {
                var containerRect = thumbnailContainer.getBoundingClientRect();
                var thumbRect = relatedThumb.getBoundingClientRect();
                var currentTop = parseInt(thumbnailContainer.style.top) || 0;

                // Check if thumbnail is above the visible area
                if(thumbRect.top < containerRect.top) {
                  var scrollAmount = containerRect.top - thumbRect.top;
                  thumbnailContainer.style.top = (currentTop + scrollAmount) + 'px';
                }
                // Check if thumbnail is below the visible area
                else if(thumbRect.bottom > containerRect.bottom) {
                  var scrollAmount = thumbRect.bottom - containerRect.bottom;
                  thumbnailContainer.style.top = (currentTop - scrollAmount) + 'px';
                }
              }
            }
          }
        }
      });

    });
  }

  let mainTabsContent =  document.getElementById('yvProductFeatureListwrapper');
  if(mainTabsContent){
    // setTimeout(function(){
    //   let headerMain = document.getElementById('headerSection');
    //   let body = document.querySelector('body');
    //   let headerHeight = headerMain.offsetHeight+5;
    //   if(body.classList.contains('sticky-header')){
    //     mainTabsContent.style.top = headerHeight+'px';
    //   }
    //   else{
    //     mainTabsContent.style.top = '5px';    	
    //   }
    // },300);
    let contentTabs = document.getElementsByClassName('yv-product-feature');

	
    window.addEventListener('scroll', function(event){
     
      Array.from(contentTabs).forEach(function(item) {
        if (isOnScreen(item)) {
          let headTabs = document.getElementsByClassName('feature-link');
          Array.from(headTabs).forEach(function(head) {
            head.parentNode.classList.remove('active');
          });
          var relatedHead = document.querySelector('.feature-link[href="#'+item.id+'"]');
          if(relatedHead){
            relatedHead.parentNode.classList.add('active');
          }
        }
      });

    });
  }
}

function initStickyAddToCart(){
  let mainProductForm =  document.querySelector('.main-product-form[action^="'+cartAdd+'"]');
  if(mainProductForm){
    let stickyBar =  document.getElementById('yvProductStickyBar');
    if(stickyBar){
      window.addEventListener('scroll', function(event){
        if (isOnScreen(mainProductForm,true)) {
          stickyBar.classList.remove('show');
        }else{     
          stickyBar.classList.add('show');
        }
      });  	
    }
  }
}

function sizeChart(){
  var sizeChartInit = document.querySelectorAll('.sizeChart-label');
  if(sizeChartInit){
    var sizeChartModel = document.getElementById('sizeChartModel');
    if(sizeChartModel){
      var sizeChartClose = sizeChartModel.querySelector('#sizeChartClose');
      sizeChartInit.forEach(function (sizeChart) {
      sizeChart.addEventListener("click", (e)=>{ 
        e.preventDefault();             
        sizeChartModel.fadeIn(100);
        document.querySelector('body').classList.add('sizeChartOpen'); 
        focusElement = sizeChart;
        sizeChartClose.focus();
      });
      });
      sizeChartClose.addEventListener("click", ()=>{
        document.querySelector('body').classList.remove('sizeChartOpen');
        sizeChartModel.fadeOut(100);
        focusElement.focus();
        focusElement='';
    });
  }
}
}
// function ThzhotspotPosition(evt, el, hotspotsize, percent) {
//   var left = el.offset().left;
//   var top = el.offset().top;
//   var hotspot = hotspotsize ? hotspotsize : 0;
//   if (percent) {
//     x = (evt.pageX - left - (hotspot / 2)) / el.outerWidth() * 100 + '%';
//     y = (evt.pageY - top - (hotspot / 2)) / el.outerHeight() * 100 + '%';
//   } else {
//     x = (evt.pageX - left - (hotspot / 2));
//     y = (evt.pageY - top - (hotspot / 2));
//   }

//   return {
//     x: x,
//     y: y
//   };
// }

// function productZoomInit(){
//   $('[data-flickity-product-slider]').mouseenter(function(e){
//     $('.yv-product-zoom').removeClass('show');
    
//     var _target = e.target
//     if (!_target.classList.contains("yv-product-zoom")) {
//       return false;
//     }
//     var zoomElement = $(this).find('.yv-product-zoom');
//     if($(this).hasClass('flickity-enabled')){
//       zoomElement = $(this).find('.yv-product-image-item.is-selected').find('.yv-product-zoom');
//     }
//     if(window.innerWidth > 1021){
//       zoomElement.addClass('show');
//     }
//   })
//   $('[data-flickity-product-slider]').mousemove(function(e){
//     var zoomElement = $(this).find('.yv-product-zoom');
//     if($(this).hasClass('flickity-enabled')){
//       zoomElement = $(this).find('.yv-product-image-item.is-selected').find('.yv-product-zoom');
//     }
//     $('.yv-product-zoom').removeClass('show');
    
//     var _target = e.target
//     console.log('hp',_target,_target.classList.contains("yv-product-zoom"))
//     if (!_target.classList.contains("yv-product-zoom")) {
//       $('.yv-product-zoom').removeClass('show');
//       return false;
//     }
   
//     if(window.innerWidth > 1021){
//       zoomElement.addClass('show');
//       let hp = ThzhotspotPosition(e, zoomElement, 0, true); 
//       zoomElement.find('.gallery-cursor').css({
//         "top":hp.y,
//         "left":hp.x
//       });
//     }
//   })
//   $('[data-flickity-product-slider]').mouseleave(function(e){
//     $('.yv-product-zoom').removeClass('show');
//   })
// }

const getMousePos = (e) => {
  var pos = e.currentTarget.getBoundingClientRect();
  return {
    x: e.clientX - pos.left,
    y: e.clientY - pos.top,
  };
};
let zoomIconElement = document.querySelector('[zoom-icon]');
let zoomIcon = zoomIconElement ? zoomIconElement.getAttribute('zoom-icon') : null;
if(zoomIcon){
function productZoomInit(){
  $('.yv-product-zoom').mouseenter(function(e){
    $('.yv-product-zoom').removeClass('show');
    if(window.innerWidth > 1021){
      $(this).addClass('show');
    }
  })
  $('.yv-product-zoom').mousemove(function(e){
    if(window.innerWidth > 1021){
      let t = getMousePos(e);
      this.querySelector('.gallery-cursor').style.translate = `${t.x}px ${t.y}px`;
    }
  })
  $('.yv-product-zoom').mouseleave(function(e){
    $('.yv-product-zoom').removeClass('show');
  })
}
}

function initImageClickNavigation() {
  // Add click navigation to main images using Flickity
  setTimeout(() => {
    if (window.productSlider && window.productThumbSlider) {
      console.log('Setting up click navigation with Flickity sliders');

      // Add click handlers to main slider items
      const mainSliderElement = window.productSlider.element;
      const slides = mainSliderElement.querySelectorAll('.yv-product-slider-item');

      slides.forEach((slide, index) => {
        slide.addEventListener('click', function(e) {
          // Don't interfere with zoom functionality
          if (e.target.closest('.yv-product-zoom') || e.target.closest('a[data-fancybox]')) {
            return;
          }

          e.preventDefault();

          // Navigate to next slide using Flickity
          let nextIndex = (index + 1) % slides.length;
          console.log('Clicking to navigate from index', index, 'to', nextIndex);

          window.productSlider.select(nextIndex);

          // The thumbnail slider should auto-sync via asNavFor, but let's ensure it's visible
          setTimeout(() => {
            // Get the current selected thumbnail
            const selectedThumb = window.productThumbSlider.element.querySelector('.is-selected');
            if (selectedThumb) {
              console.log('Selected thumbnail:', selectedThumb);

              // Scroll thumbnail container to show the selected thumbnail
              let thumbnailContainer = document.querySelector('.yv-product-gallery-thumbs-container');
              if (!thumbnailContainer) {
                thumbnailContainer = window.productThumbSlider.element.parentElement;
              }

              if (thumbnailContainer) {
                console.log('Found thumbnail container:', thumbnailContainer);

                let containerRect = thumbnailContainer.getBoundingClientRect();
                let thumbRect = selectedThumb.getBoundingClientRect();
                let currentTop = parseInt(thumbnailContainer.style.top) || 0;

                console.log('Container rect:', containerRect);
                console.log('Thumb rect:', thumbRect);
                console.log('Current top:', currentTop);

                // Check if thumbnail is above the visible area
                if (thumbRect.top < containerRect.top) {
                  let scrollAmount = containerRect.top - thumbRect.top + 10;
                  let newTop = currentTop + scrollAmount;
                  console.log('Scrolling UP by:', scrollAmount, 'New top:', newTop);
                  thumbnailContainer.style.top = newTop + 'px';
                }
                // Check if thumbnail is below the visible area
                else if (thumbRect.bottom > containerRect.bottom) {
                  let scrollAmount = thumbRect.bottom - containerRect.bottom + 10;
                  let newTop = currentTop - scrollAmount;
                  console.log('Scrolling DOWN by:', scrollAmount, 'New top:', newTop);
                  thumbnailContainer.style.top = newTop + 'px';
                }

                console.log('Final container top:', thumbnailContainer.style.top);
              }
            }
          }, 100);
        });
      });
    } else {
      console.log('Flickity sliders not ready, retrying...');
      setTimeout(initImageClickNavigation, 500);
    }
  }, 1000);
}

// Removed custom manual navigation, selection syncing, wheel handlers, and keyboard/click overrides.

document.addEventListener("DOMContentLoaded", findVisibleItems,false);
document.addEventListener("shopify:section:load", findVisibleItems,false);

document.addEventListener("DOMContentLoaded", productZoomInit,false);
document.addEventListener("shopify:section:load", productZoomInit,false);

document.addEventListener("DOMContentLoaded", function() {
  initProductSlider();
  initProductThumbSlider();

  // Add click navigation after sliders are ready
  setTimeout(() => {
    if (window.productSlider) {
      const slides = window.productSlider.element.querySelectorAll('.yv-product-slider-item');
      slides.forEach((slide, index) => {
        slide.addEventListener('click', function(e) {
          // Don't interfere with zoom functionality
          if (e.target.closest('.yv-product-zoom') || e.target.closest('a[data-fancybox]')) {
            return;
          }

          e.preventDefault();

          // Navigate to next slide
          const nextIndex = (index + 1) % slides.length;
          window.productSlider.select(nextIndex);
        });
      });
    }
  }, 1500);

}, false);

document.addEventListener("shopify:section:load",function (event) {
  initProductSlider(event.target)
  initProductThumbSlider(event.target);
});

document.addEventListener("DOMContentLoaded", sizeChart,false);
document.addEventListener("shopify:section:load", sizeChart,false);

document.addEventListener("DOMContentLoaded", initStickyAddToCart,false);
document.addEventListener("shopify:section:load", initStickyAddToCart,false);



$(document).ready(function(){
 setTimeout(function(){
    var thumbnails = document.querySelector('.yv-product-gallery-thumbs-container');
    var lastKnownY = window.scrollY;
    var currentTop = 0;
    if(thumbnails){
      var initialTopOffset = parseInt(window.getComputedStyle(thumbnails).top);

      window.addEventListener('scroll', function(){
        var  bounds = thumbnails.getBoundingClientRect(),
            maxTop = bounds.top + window.scrollY - thumbnails.offsetTop,
            minTop = thumbnails.clientHeight - window.innerHeight;

        if (window.scrollY < lastKnownY) {
          currentTop -= window.scrollY - lastKnownY;
        } else {
          currentTop += lastKnownY - window.scrollY;
        }

        // Remove initialTopOffset constraint to allow upward movement
        currentTop = Math.min(Math.max(currentTop, -minTop), maxTop);
        lastKnownY = window.scrollY;
        thumbnails.style.top = "".concat(currentTop, "px");
      });
    }
  },1000)

  jQuery('body').on('click','.gallery-thumbs-item',function(e) {
    e.preventDefault();
    var destination = jQuery(this).attr('data-image');
    var top = 10;
  //  if(jQuery('#headerSection').hasClass('sticky-header')){
      top = jQuery('.shopify-section-main-header').height() + 10;
  //  }
    if(jQuery('#'+destination+'.gallery-main-item').length > 0){
      jQuery('html,body').animate({ scrollTop:(jQuery('#'+destination+'.gallery-main-item').offset().top) - top});
    }

    // Also scroll thumbnail container to ensure clicked thumbnail is visible
    var thumbnailContainer = jQuery('.yv-product-gallery-thumbs-container');
    if(thumbnailContainer.length > 0) {
      var clickedThumb = jQuery(this);
      var containerTop = thumbnailContainer.offset().top;
      var containerHeight = thumbnailContainer.height();
      var thumbTop = clickedThumb.offset().top;
      var thumbHeight = clickedThumb.height();

      // Check if thumbnail is above the visible area
      if(thumbTop < containerTop) {
        var scrollAmount = containerTop - thumbTop;
        var currentTop = parseInt(thumbnailContainer.css('top')) || 0;
        thumbnailContainer.css('top', (currentTop + scrollAmount) + 'px');
      }
      // Check if thumbnail is below the visible area
      else if(thumbTop + thumbHeight > containerTop + containerHeight) {
        var scrollAmount = (thumbTop + thumbHeight) - (containerTop + containerHeight);
        var currentTop = parseInt(thumbnailContainer.css('top')) || 0;
        thumbnailContainer.css('top', (currentTop - scrollAmount) + 'px');
      }
    }
  });


  jQuery('body').on('click','.pdp-view-close',function(e) {
    e.preventDefault();
    jQuery('#yvProductStickyBar').remove();    
  });
  jQuery('body').on('click','.feature-link',function(e) {
    e.preventDefault();

    let destination = jQuery(this).attr('href');
    let top = 10;
    // if(jQuery('#headerSection').hasClass('sticky-header')){
      top = jQuery('.shopify-section-main-header').height() + 90;
    // }
    if(jQuery(destination).length > 0){
      jQuery('html,body').animate({ scrollTop:(jQuery(destination).offset().top) - top});
    }
  });


  jQuery('body').on('change','.sticky-bar-product-options',function(){
    let _section = jQuery(this).closest('.shopify-section');
    let option = jQuery(this).attr('data-name');
    let value = jQuery(this).val();
    let mainOption = _section.find('.productOption[name="'+option+'"]');
    if(mainOption.is(':radio')){
      _section.find('.productOption[name="'+option+'"][value="'+value+'"]').attr('checked',true).trigger('click');
    }
    else{
      mainOption.val(value);
      let sectionId = document.querySelector('#'+_section.attr('id'))
      if(sectionId){
        let optionSelector = document.querySelector('.productOption[name="'+option+'"]');
        if(optionSelector){
          optionSelector.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }    
  })
  if(fancySelector && typeof Fancybox !== 'undefined'){
      Fancybox.bind(fancySelector, {
      touch: false,
      thumbs : {
        autoStart : true
      },
      on: {
        load: (fancybox, slide) => {
          document.querySelectorAll('.yv-youtube-video').forEach((video) => {
            video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
          });
          document.querySelectorAll('.yv-youtube-video').forEach((video) => {
            video.contentWindow.postMessage('{"method":"pause"}', '*');
          });
          document.querySelectorAll('video').forEach((video) => video.pause());
          var fancyBoxContainer = $('body').find('.fancybox__container');
        },
        done: (fancybox, slide) => {
          var fancyBoxContainer = $('body').find('.fancybox__container');
        }
      },
      Toolbar: {
        display: [
          "close",
        ],
      }
      });
    }
})